// src/auth/session.js
import { redirect } from "react-router-dom";
import { API_URL } from "../config/api";

const STORAGE_KEY = "auth.session.v1";

/** @typedef {{ id:string, name:string, role:string, tenant_id:number }} AuthedUser */

export function getUserFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveUserToStorage(user) {
  try {
    if (user) localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {}
}

export async function checkSessionOnServer(signal) {
  try {
    const res = await fetch(API_URL.AUTH_STATUS, {
      credentials: "include",
      signal,
    });
    if (!res.ok) return null;

    const data = await res.json();
    if (!data?.authenticated) return null;

    const user = {
      id: data.id ?? "",
      tenant_id: data.tenant_id ?? -1,
      name: data.name ?? "",
      role: String(data.role ?? "USER").toUpperCase(),
    };
    return user;
  } catch {
    // ❗ 네트워크 에러 포함: "서버 세션 확인 실패" → 인증 실패로 처리
    return null;
  }
}

/**
 * loader에서 "로그인 필요"를 강제하고 사용자 정보를 반환
 * @param {Request} request
 * @returns {Promise<AuthedUser>}
 */
export async function requireUser(request) {
  // ✅ 오직 서버 결과만 신뢰
  const user = await checkSessionOnServer(request?.signal);

  if (!user) {
    const url = new URL(request.url);
    const to = `/login?from=${encodeURIComponent(url.pathname + url.search)}`;
    throw redirect(to);
  }

  // 서버가 인증한 최신값을 저장(동기화)
  saveUserToStorage(user);
  return user;
}
